import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { GuestBase } from 'src/app/models/waiver';
import { StoreService } from 'src/app/services/store.service';
import { Utility } from 'src/app/common/utility';
import { WaiverSteps } from 'src/app/alv-enums';
import { WaiverService } from 'src/app/services/waiver.service';
import { ToolsService } from 'src/app/services/tools.service';
import * as moment from 'moment'
@Component({
  selector: 'guest-selection',
  templateUrl: './guest-selection.component.html',
  styleUrls: ['./guest-selection.component.scss']
})
export class GuestSelectionComponent implements OnInit {
  guests: GuestBase[];

  @Output() private stepChange = new EventEmitter<WaiverSteps>();
  @Output() protected waiverCompleted = new EventEmitter<void>();
  constructor(public storeService: StoreService, public waiverService: WaiverService
    , public toolsService: ToolsService) { }
  utility = Utility; // this is to allow Utility enum to be used in html
  ngOnInit() {
    let self = this;
    self.guests = self.storeService.waiver.guests;

  }
  get selectedGuests() : GuestBase[]
  {
    let self = this;
    return self.guests.filter(g=>g.selected== true)
  }
  goToStep() {
    const self = this;
    //if any of the guests selected do not have a waiver then go to waiver sign up page
    if (self.guests.filter(g=>g.selected== true).findIndex(g => g.waiverInfo.waiverStatus == "No Current Waiver") > -1) {
      self.waiverService.onStepChangeForward(WaiverSteps.signWaiver)
    }
    else {
      this.waiverCompleted.emit();
    }
  }
  onSubmit() {
    const self = this;
    this.storeService.waiver.guests = this.guests;
    this.goToStep();
    window.scroll(0,0)
  }
  toggleSlection(guestId: number) {
    let guest = this.guests.find(g => g.guestId == guestId);
    guest.selected = !guest.selected;
  }
  goToAddGuests(){
    const self = this;
    self.waiverService.onStepChangeForward(WaiverSteps.addGuests)
    window.scroll(0, 0)
  }
}
